import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AppState from '../../../models/redux/state/app.state';
import useProfileHook from '../../../services/profileHook';

const AdminRoute: React.FC<{
  component: React.FC;
  path: string;
  tempUserAccess?: boolean;
}> = (props) => {
  useProfileHook();
  const user = useSelector((state: AppState) => state.auth.user || { isAdmin: false });
  const { isAdmin } = user;

  const { component, path } = { ...props };
  return isAdmin ? <Route path={path} component={component} /> : <Redirect to="/" />;
};

export default AdminRoute;
